export enum NewContactType {
  NEW = "NEW",
  EXISTING = "EXISTING",
}
